import React from 'react';
import './Footer.css';
import shapeBg from '../../../assets/Home/shape-bg.png';  // Resmi import ettik

export default function Footer() {
  return (
    <div className='footer-container'>
      <div className='footer-parent'>
       
      </div>
    </div>
  );
}
